package com.evoapps.evoshift.domain.usecase.settings

import com.evoapps.evoshift.domain.model.RecurringCostRule
import com.evoapps.evoshift.domain.repository.WorkplaceRepository

class UpdateRecurringCostRuleUseCase(
    private val workplaceRepository: WorkplaceRepository
) {
    suspend operator fun invoke(ownerId: String, rule: RecurringCostRule): Result<Unit> {
        return workplaceRepository.updateRecurringCostRule(ownerId, rule)
    }
}
